module.exports = __webpack_public_path__ + "img/banner13-2@2x.f83b2ce7.jpg";